import { render, staticRenderFns } from "./AgentsChats.vue?vue&type=template&id=5913a6aa&scoped=true"
import script from "./AgentsChats.vue?vue&type=script&lang=js"
export * from "./AgentsChats.vue?vue&type=script&lang=js"
import style0 from "./AgentsChats.vue?vue&type=style&index=0&id=5913a6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913a6aa",
  null
  
)

export default component.exports